const generateRowId = () => `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

const CONTROL_PLAYER_FIELDS = [
  'Player',
  'Operator',
  'Score',
  'K',
  'D',
  'A',
  'Impact',
  'Damage',
  'CaptureKills',
  'OperatorValue',
];

const MATCH_LEVEL_FIELDS = [
  'Team',
  'Region',
  'VS',
  'Date',
  'ModeID',
  'Map',
  'MatchType',
  'MatchTypeId',
  'MatchCategory',
  'MatchTypeRegion',
  'WinLose',
  'PF',
  'PA',
];

const toFormNumberString = (value) => (
  value === null || value === undefined ? '' : String(value)
);

const pickMatchLevelFields = (baseRow = {}) => MATCH_LEVEL_FIELDS.reduce((next, fieldKey) => {
  if (baseRow[fieldKey] !== undefined) {
    next[fieldKey] = baseRow[fieldKey];
  }
  return next;
}, {});

export const mapControlPreviewRowToFormRow = (previewRow, baseRow = {}) => ({
  ...pickMatchLevelFields(baseRow),
  _rowId: baseRow._rowId || generateRowId(),
  Player: previewRow.playerName || '',
  Operator: previewRow.operator || '',
  Score: toFormNumberString(previewRow.score),
  K: toFormNumberString(previewRow.kills),
  D: toFormNumberString(previewRow.deaths),
  A: toFormNumberString(previewRow.assists),
  Impact: toFormNumberString(previewRow.impact),
  Damage: toFormNumberString(previewRow.damage),
  CaptureKills: toFormNumberString(previewRow.captureKills),
  OperatorValue: toFormNumberString(previewRow.operatorValue),
});

export const mapControlPreviewRowsToFormRows = (previewRows = [], existingRows = []) => {
  const firstExistingRow = existingRows[0] || {};

  return previewRows.map((previewRow, index) => mapControlPreviewRowToFormRow(
    previewRow,
    {
      ...firstExistingRow,
      ...(existingRows[index]?._rowId ? { _rowId: existingRows[index]._rowId } : {}),
    }
  ));
};

export const hasMeaningfulControlPlayerStatsRows = (rows = []) => rows.some((row) => (
  CONTROL_PLAYER_FIELDS.some((fieldKey) => {
    const value = row?.[fieldKey];
    return value !== undefined && value !== null && String(value).trim() !== '';
  })
));
